import React, { ReactNode } from 'react';
import InnerSwitch, { ReactSwitchProps } from 'react-switch';
import styled from 'styled-components';

interface ContainerProps {
  $labelAboveSwitch?: boolean;
}

const Container = styled.label<ContainerProps>`
  display: flex;
  flex-direction: ${props => (props.$labelAboveSwitch ? 'column-reverse' : 'row')};
  align-items: ${props => (props.$labelAboveSwitch ? 'flex-start' : 'center')};
  margin: ${props => (props.$labelAboveSwitch ? '0' : '20px 0')};
  justify-content: ${props => (props.$labelAboveSwitch ? 'center' : 'flex-start')};
`;

const SwitchWrapper = styled.div<ContainerProps>`
  margin-right: ${props => (props.$labelAboveSwitch ? '0' : '10px')};
  margin-top: ${props => (props.$labelAboveSwitch ? '10px' : '0')};
  margin-bottom: ${props => (props.$labelAboveSwitch ? '10px' : '0')};
`;

interface Props extends Omit<ReactSwitchProps, 'onChange'> {
  labelAboveSwitch?: boolean;
  label?: string;
  children?: ReactNode;
  onChange: (checked: boolean) => void;
}

export const Switch: React.FC<Props> = ({ labelAboveSwitch, label, children, ...switchProps }) => {
  return (
    <Container $labelAboveSwitch={labelAboveSwitch}>
      <SwitchWrapper $labelAboveSwitch={labelAboveSwitch}>
        <InnerSwitch {...switchProps}>{children}</InnerSwitch>
      </SwitchWrapper>
      {label}
    </Container>
  );
};

export default Switch;
